import ScaleRepository from "@/repositories/tuevs/ScaleRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'scale',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ScaleRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.scale)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await ScaleRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', {
                    ...state.pagination,
                    total: response.data.total
                })
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await ScaleRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
